import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const PrayerWithParentsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColLeft}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}StartEarly.png`} className={`${styles.highlightsItemHeaderImgIcon} `} />
                  <p className={styles.highlightsItemHeaderTitle} > DON'T WAIT </p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} >
                        <b>Don't save your prayers for later.</b><br/>
                        Praying regularly throughout the day can help to build a deeper relationship with God.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={6} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ReconnectingIcon.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} > COMMUNITY </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b>Pray with and for others.</b><br/>
                        Older adults should ask people in their community (church members, friends/family, people in their 
                        assisted-living facilities if applicable) how they can pray for them. This can help to form bonds 
                        with other as well as evoke feelings of helpfulness.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={5} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColRight}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} > 
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Music.png`} className={`${styles.highlightsItemHeaderImgIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} > MUSIC </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        <b>Bring joy with music.</b><br/>
                        A good way to bring positive vibes to the day is to use music for worship. Singing along or 
                        even just listening to favorite worship songs can bring the older adult peace.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips for a Strong Prayer Life for Older Adults </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}PrayerWithParentsLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(PrayerWithParentsLearnMore);
